"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var component_1 = __importDefault(require("@loadable/component"));
var react_1 = require("react");
var LeaderboardTable = (0, component_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () {
    var Table;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("./LeaderboardTable")); })];
            case 1:
                Table = _a.sent();
                return [2 /*return*/, Table.LeaderboardTable];
        }
    });
}); });
var ph_domain_1 = require("@phantom/ph-domain");
var useRequests_1 = __importDefault(require("../../hooks/useRequests"));
var RaceLeaderboards = function (props) {
    var currency = props.currency, userId = props.userId, brandId = props.brandId, limit = props.limit, _a = props.fetchInterval, fetchInterval = _a === void 0 ? 2 * 1000 : _a;
    var getLeaderboards = (0, useRequests_1.default)().getLeaderboards;
    var _b = (0, react_1.useState)([]), data = _b[0], setData = _b[1];
    var intervalId = (0, react_1.useRef)();
    var getNonExpiredTournaments = function (tournaments) {
        return tournaments.filter(function (tournament) { return new Date(tournament.end).getTime() > Date.now(); });
    };
    var tournamentExists = function (tournament, tournaments) {
        return tournaments.findIndex(function (leaderboardTournament) { return leaderboardTournament.instanceId === tournament.instanceId; }) > -1;
    };
    var fetchTournaments = function (onlyRunning) {
        if (onlyRunning === void 0) { onlyRunning = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var tournaments, newTournaments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getLeaderboards({
                            userId: userId,
                            brandId: brandId,
                            currency: currency,
                            limit: limit,
                            status: onlyRunning ? "".concat(ph_domain_1.FeatureStatus.Pending, ",").concat(ph_domain_1.FeatureStatus.Running) : "",
                        })];
                    case 1:
                        tournaments = _a.sent();
                        newTournaments = tournaments.response;
                        if (onlyRunning) {
                            setData(function (prevTournaments) {
                                var nonExpiredTournaments = getNonExpiredTournaments(prevTournaments);
                                if (newTournaments.length > nonExpiredTournaments.length) {
                                    return __spreadArray(__spreadArray([], prevTournaments, true), newTournaments, true).reduce(function (tournaments, tournament) {
                                        if (!tournamentExists(tournament, tournaments)) {
                                            return __spreadArray(__spreadArray([], tournaments, true), [tournament], false);
                                        }
                                        return tournaments;
                                    }, []).sort(function (tournamentA, tournamentB) { return new Date(tournamentB.start).getTime() - new Date(tournamentA.start).getTime(); });
                                }
                                return prevTournaments.map(function (prevTournament) {
                                    var newTournament = newTournaments.find(function (tournament) { return tournament.code === prevTournament.code; });
                                    if (newTournament) {
                                        return __assign(__assign({}, prevTournament), newTournament);
                                    }
                                    return prevTournament;
                                });
                            });
                        }
                        else {
                            setData(newTournaments || []);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        fetchTournaments(false);
        intervalId.current = setInterval(fetchTournaments, fetchInterval);
        return function () { return clearInterval(intervalId.current); };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: data.map(function (tournament, idx) { return ((0, jsx_runtime_1.jsx)(LeaderboardTable, __assign({}, props, { data: tournament }), idx)); }) }));
};
exports.default = RaceLeaderboards;
